//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'login',
  data () {
    return {
      info:{},
      password:'',
      password1:'',
      password2:'',
    }
  },
  created(){
  },
  methods:{
    account(){
      this.$api.account({}).then((res)=>{
        if(res){
         this.info = res.data;
        }
      })
    },
    submit(){
        let that = this;
        if (!this.password) {
            that.$func.showToast('请输入原密码');
            return false;
        }
        if (!this.password1) {
            that.$func.showToast('请输入新密码');
            return false;
        }
        if (this.password1 != this.password2) {
            that.$func.showToast('两次输入密码不一致');
            return false;
        }
        this.$func.confirm('确认修改？','提示',()=>{
          that.$api.password({password:that.password,password1:that.password1,password2:that.password2}).then((res)=>{
            if(res){
              // that.$func.alert('您的新密码为 "'+that.password1+ '" 请使用新密码登录','操作成功');
              that.$api.out({}).then((res)=>{
                that.$router.push({path:'/login'})
              })
            }
          });
        });
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/password.vue